var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 154.999,
    viewBox: "0 0 140 154.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#57b0ff;}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 140,
    height: 154.999,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-226 -1410)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 226, 1410)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-6357-59h-42a4,4,0,0,1-4-4v-57a4,4,0,0,1,4-4h30l16,16v45A4,4,0,0,1-6357-59Z",
    transform: "translate(6433 154)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0,16,16H4a4,4,0,0,1-4-4Z",
    transform: "translate(290 1440)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 8,
    height: 2,
    rx: 1,
    transform: "translate(266 1462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 25,
    height: 2,
    rx: 1,
    transform: "translate(266 1470)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 25,
    height: 2,
    rx: 1,
    transform: "translate(266 1478)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 8,
    height: 2,
    rx: 1,
    transform: "translate(266 1486)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.fc50e6f47ab6d5eba7d80f34cc02603e.svg";
export { ForwardRef as ReactComponent };